export default {
    downloadPDF(dados, filename) {
        const base64PDF = dados;

        const binaryString = window.atob(base64PDF);
        const byteArray = new Uint8Array(binaryString.length);

        for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "application/pdf" });

        this.downloadPDFBlob(blob, filename);
    },
    downloadPDFBlob(blob, filename) {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${filename}.pdf`;
        link.click();

        URL.revokeObjectURL(link.href);

        link.remove();
    },
    downloadXLSXBlob(blob, fileName = "arquivo") {
        if (!(blob instanceof Blob)) {
            throw new Error("O parâmetro fornecido não é um Blob válido.");
        }

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    },
    downloadXLSX2(dados, filename) {
        var dlnk = document.createElement("a");
        dlnk.download = `${filename}.xlsx`;
        objectUrl = window.URL.createObjectURL(dados);
        dlnk.href = objectUrl;
        dlnk.click();
        objectUrl && window.URL.revokeObjectURL(objectUrl);
        dlnk.remove();
    },
    downloadXLSX(dados, filename) {
        let csv = "data:text/csv;charset=utf-8,";
        csv += dados;

        const link = document.createElement("a");
        link.setAttribute("href", encodeURI(csv));
        link.setAttribute("download", `${filename}.xlsx`);
        document.body.append(link);
        link.click();
        link.remove();
    },
    downloadCSV(dados, filename) {
        let csv = "data:text/csv;charset=utf-8," + dados;
        const link = document.createElement("a");
        link.setAttribute("href", encodeURI(csv));
        link.setAttribute("download", `${filename}.csv`);
        document.body.append(link);
        link.click();
        link.remove();
    },
    downloadTXT(dados, filename) {
        const blob = new Blob([dados], { type: "text/plain;charset=utf-8" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    },
    downloadZIP(dados, filename) {
        const byteCharacters = atob(dados)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: "application/zip" })
        const link = document.createElement("a")

        link.href = URL.createObjectURL(blob)
        link.download = filename || "arquivo.zip"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
    },
};
